import { QuizApp } from "./app";
import { initializeTracking } from "./analytics/tracking";
import { revealInitialFrameWhenReady } from "./components/BootLoader";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";
import "./styles/main.css";
import "./styles/campaign.css";
import "./styles/compact-flow.css";
import "./styles/comic-quest.css";
import "./styles/mistychna-ukraina.css";
import "./styles/booking-flow.css";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("Missing #app root");

if (window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/")) {
  document.querySelector("#boot-loader")?.remove();
  document.documentElement.dataset.admin = "true";
  document.title = "Quiz Analytics";
  void import("./admin/AdminApp").then(({ AdminApp }) => new AdminApp(root).start());
} else {
  initializeTracking();
  new QuizApp(root).start();
  revealInitialFrameWhenReady(root);
}
